import { createTheme } from "@material-ui/core/styles";
import baseTheme from "../../universal/theme";

const listingTheme = createTheme({
  direction: baseTheme.direction,
  palette: {
    primary: {
      light: baseTheme.palette.primary.light,
      main: baseTheme.palette.primary.main,
      dark: baseTheme.palette.primary.dark,
      contrastText: baseTheme.palette.primary.contrastText,
    },
    secondary: {
      light: baseTheme.palette.secondary.light,
      main: baseTheme.palette.secondary.main,
      dark: baseTheme.palette.secondary.dark,
      contrastText: baseTheme.palette.secondary.contrastText,
    },
  },
  typography: {
    fontFamily: '"Heebo", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: { fontWeight: 700 },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 700 },
    subtitle1: { fontWeight: 600 },
    subtitle2: { fontWeight: 600 },
    button: {
      textTransform: "none",
      fontWeight: 600,
    },
    overline: {
      fontWeight: 600,
      textTransform: "none",
    },
  },
});

export default listingTheme;
